$(function main() {
  var $win = $(window);
  var $doc = $(document);
  var $head = $("header.page-header");
  var $foot = $("footer.page-footer");
  var $bt = $(".back-to-top");
  var $anchors = $("nav.anchors");
  var $anclinks = $anchors.find("a");
  var $progress = $("nav.anchors").find(".progress");

  var dest;

  var getOffset = function getOffset() {
    var offset = 0;

    if (typeof $AM === "function") {
      offset += 62;
    }

    offset += $head.outerHeight();

    if ($anchors.length > 0) {
      offset += $anchors.outerHeight();
    }
    return offset;
  };

  var scrollEvents = throttle(function scrollIt() {
    var st = $doc.scrollTop();
    var sb = st + $win.innerHeight();
    var bottom = $foot.offset().top;

    if (st < 250 && !$bt.hasClass("hidden")) {
      $bt.addClass("hidden");
    } else if (st > 250 && $bt.hasClass("hidden")) {
      $bt.removeClass("hidden");
    }

    // if ((sb - $bt.height()) >= bottom && !$bt.hasClass("stuck")) {
    //   $bt.addClass("stuck");
    // } else if ((sb - $bt.height()) < bottom && $bt.hasClass("stuck")) {
    //   $bt.removeClass("stuck");
    // }

    if ($anchors.length > 0) {
      $("main > div").each(function ancWaypoint(idx, elm) {
        var id = elm.id;
        var $div = $(this);
        var $link = $anclinks.filter("[href='#" + id + "']");
        var topoff = $div.offset().top - st;

        if ($link.length > 0 && topoff > 0 && topoff < 250) {
          $anclinks.removeClass("active");
          $link.addClass("active");
        } if ($link.length > 0 && topoff > 500) {
          $link.removeClass("active");
        }
      });
    }

    // $progress.css("width", per + "%");

  }, 250);

  window.addEventListener("scroll", scrollEvents);

  $anchors.stickybits({
    stickyBitStickyOffset: (typeof $AM === "function" ? 62 : 0)
  });

  $anclinks.on("click", function navAnchorClick() {
    var $this = $(this);

    window.removeEventListener("scroll", scrollEvents);
    $this.parent().find("a").not($this).removeClass("active");
    $this.addClass("active");
    setTimeout(function putBackScroll() {
      window.addEventListener("scroll", scrollEvents);
    }, 1000);
  });

  $("[href^=\"#\"]").not("[rel=\"lightbox\"]").not(".tab-headers a").on("click", function hashClick(e) {
    var $this = $(this);
    var $anchor = $($this.attr("href"));
    if ($anchor.length > 0) {
      e.preventDefault();

      $("html,body").animate({
        scrollTop: $anchor.offset().top - getOffset()
      });
      if (typeof history.pushState === "function") {
        history.pushState(undefined, undefined, location.href);
        history.replaceState(undefined, undefined, $this.attr("href"));
      }
    }
  });

  if (location.hash) {

    // Kind of weird work around to prevent scrolling
    $dest = $(location.hash);
    window.scrollTo(0, 0);
    setTimeout(function startAtTop() {
      window.scrollTo(0, 0);
    }, 1);

    if ($dest.length > 0) {
      setTimeout(function scrollOnLoad() {
        window.scrollTo(0, 0);
        $("html,body").animate({
          scrollTop: ($dest.offset().top - getOffset())
        }, 1250);
      }, 250);
    }
  }
});
